<template>
  <div :class="$style.style"  v-if="frontUrl&&frontUrl!=''">
    <div class="content">
      <iframe :src="frontUrl" frameborder="none" :name="'long-iframe_'+ifid" scrolling="yes" :id="ifid" @onload="onLoad()" allow="autoplay"></iframe>
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    frontUrl: { type: String, default: '' },
    ifid: { type: String, default: '' }
  },
  data() {
    return {
      // 初始化空对象
      chart: null
    };
  },
  computed: {
  },
  methods: {
    onLoad: function() {
      // let evt = document.createEvent("HTMLEvents");
      // evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      // evt.click()
      // document.getElementById(ifid).contentWindow.location.reload(true);
    }
  },
  mounted() {
    // (function(m, ei, q, i, a, j, s) {
    //   m[i] =
    //     m[i] ||
    //     function() {
    //       (m[i].a = m[i].a || []).push(arguments);
    //     };
    //   (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
    //   j.async = true;
    //   j.charset = 'UTF-8';
    //   j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t';
    //   s.parentNode.insertBefore(j, s);
    // })(window, document, 'script', '_MEIQIA');
    // _MEIQIA('entId', 56684);
  },
  beforeCreate() {
    document.domain = 'jianyewy.com';
  }
};
</script>
<style lang="less" module>
:local(.style) {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height:100%;
  padding-top: 20px;
  background: #ffffff;
  iframe {
    width: 100%;
    height: 100%;
    min-height: 1000px;
  }
  .content {
    position: fixed;
    left: 240px;
    right: 0;
    top: 120px;
    bottom: 40px;
    overflow: auto;
  }
  .footer {
    overflow-y: hidden;
    // background: #FFFFFF;
    height: 140px;
  }
}
</style>
